import { memo } from 'preact/compat';

import cx from 'clsx';

import styles from './DotsLoader.module.scss';

/**
 * DotsLoader — animated three-dot loader intended for use inside a Button.
 * Dots use `currentColor` so they automatically inherit the button's text color.
 */
const DotsLoader = memo(() => (
	<div className="d-flex gap1 content-center justify-center">
		<span className={cx(styles.dot, 'bg-primaryLabel')} />
		<span className={cx(styles.dot, 'bg-primaryLabel')} />
		<span className={cx(styles.dot, 'bg-primaryLabel')} />
	</div>
));

export default DotsLoader;
